"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const modal_1 = __importDefault(require("../modal/modal"));
const paginatedMessageComponent_1 = __importDefault(require("../messageComponent/paginatedMessageComponent"));
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const scheduleActionsTable_1 = __importDefault(require("./scheduleActionsTable"));
const ScheduleActionsModal = ({ visible, hideModal, onPageChange, }) => {
    const { totalEntries } = useAppSelector_1.default((state) => ({
        totalEntries: state.actions.scheduleActions.totalEntries,
    }));
    return (react_1.default.createElement(modal_1.default, { title: "Schedule Actions", visible: visible, hideModal: hideModal, containerStyle: styles_1.default.modelFormTop },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.modalWidth },
            totalEntries !== 0 && react_1.default.createElement(scheduleActionsTable_1.default, { onPageChange: onPageChange }),
            totalEntries === 0 && (react_1.default.createElement(paginatedMessageComponent_1.default, { message: "No actions Found.", color: colors_1.default.BLUE, icon: free_solid_svg_icons_1.faSadTear })))));
};
exports.default = ScheduleActionsModal;
